import {
  Button,
  Card,
  Group,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { Activity, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function Research() {
  const navigate = useNavigate();

  return (
    <Stack gap='md'>
      <div>
        <Group justify='space-between' align='flex-start'>
          <div>
            <Title>RICERCA</Title>
            <Text c='dimmed'>
              Strumenti di analisi per dati clinici e sessioni completed.
            </Text>
          </div>
          <Button
            variant='light'
            leftSection={<BookOpen size={16} />}
            onClick={() =>
              navigate('/research/spectral-normalization/documentation')
            }
          >
            Documentazione
          </Button>
        </Group>
      </div>

      <SimpleGrid cols={{ base: 1, md: 2, xl: 3 }}>
        <Card
          withBorder
          shadow='sm'
          padding='lg'
          radius='md'
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/research/spectral-normalization')}
        >
          <Stack gap='md'>
            <ThemeIcon size={54} radius='md' variant='light' color='blue'>
              <Activity size={28} />
            </ThemeIcon>
            <div>
              <Title order={4}>Normalizzazione spettrale</Title>
              <Text size='sm' c='dimmed'>
                Confronto temporale di sessioni completed su HR, HRV, LF e HF
                con media di gruppo, spettri e validazione statistica.
              </Text>
            </div>
          </Stack>
        </Card>
      </SimpleGrid>
    </Stack>
  );
}

export default Research;
